/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cp_Form_TitleInputs */

const en_cp_form_title = /** @type {(inputs: Cp_Form_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apply for a partnership`)
};

const id_cp_form_title = /** @type {(inputs: Cp_Form_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ajukan kerjasama`)
};

/**
* | output |
* | --- |
* | "Apply for a partnership" |
*
* @param {Cp_Form_TitleInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const cp_form_title = /** @type {((inputs?: Cp_Form_TitleInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cp_Form_TitleInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_cp_form_title(inputs)
	return en_cp_form_title(inputs)
});